import moment from 'moment';

export const getFormatDate = (time, formatStr = 'YYYY-MM-DD HH:mm') => {
  if (time) {
    return moment(time).format(formatStr);
  }

  return '--';
};